var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6F8194",
    fillRule: "evenodd",
    d: "M8.75 14.167c-.214 0-.427-.082-.59-.245-.325-.325-.325-.852 0-1.178l2.755-2.754-2.65-2.744c-.32-.332-.31-.86.02-1.178.332-.32.86-.31 1.179.02l3.218 3.333c.316.327.312.847-.01 1.168L9.34 13.922c-.163.163-.376.245-.59.245z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-right.a71ac11d.svg";
export { ForwardRef as ReactComponent };